import { Injectable } from '@angular/core';
import { MatDialog } from '@angular/material/dialog';
import { Observable } from 'rxjs';
import { PatientConsentComponent } from '../../components/patient-consent/patient-consent.component';


@Injectable({
  providedIn: 'root'
})
export class ConsentService {
 constructor(
    private readonly dialog: MatDialog,
  ) { }

  showPopup(): Observable<boolean> {
    const dialogRef = this.dialog.open(PatientConsentComponent, {
      panelClass: 'dialog-class',
      backdropClass: 'dialog-blur-backdrop',
      data: {},
      disableClose: false
    });

    return dialogRef.afterClosed();
  }
}
